const { REACT_APP_BACKEND_URL } = process.env;

export default function getUrl(url = "") {
  return `${REACT_APP_BACKEND_URL}/${url}`;
}
